import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import ru from './locales/ru.json'

const LOCALE_KEY = 'locale'

function getStoredLocale(): string {
  const stored = localStorage.getItem(LOCALE_KEY)
  if (stored && ['en', 'ru'].includes(stored)) {
    return stored
  }
  const browserLang = navigator.language.split('-')[0] ?? ''
  return ['en', 'ru'].includes(browserLang) ? browserLang : 'en'
}

export const i18n = createI18n({
  legacy: false,
  locale: getStoredLocale(),
  fallbackLocale: 'en',
  messages: {
    en,
    ru,
  },
})

export function setLocale(locale: string) {
  if (['en', 'ru'].includes(locale)) {
    i18n.global.locale.value = locale as 'en' | 'ru'
    localStorage.setItem(LOCALE_KEY, locale)
  }
}

export function getLocale(): string {
  return i18n.global.locale.value
}
